import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 16px;
  color: ${myPalette.dimGray.main};
  margin-bottom: 24px;
`
